import Theme from '@adsk/alloy-react-theme';
import styled, { css } from 'styled-components';

export const GeocoderWrapperStyled = styled.div`
  ${(props) =>
    !props.isInModal &&
    css`
      position: relative;
    `}

  .mapboxgl-ctrl-geocoder {
    font-family: 'Artifakt Element';
    background-color: ${Theme.colors.white};
  }

  .mapboxgl-ctrl-geocoder .suggestions-wrapper {
    position: absolute;
    z-index: ${Theme.zIndex.dateSelector};
    background-color: ${Theme.colors.white};
    border-radius: 4px;
    box-shadow: ${Theme.shadows.highElevation};
    overflow: hidden;
    ${(props) =>
      props.isInModal &&
      css`
        left: 25px;
        right: 25px;
        transform: translateY(-${props.suggestionsOffset}px);
        width: ${props.suggestionsOffsetWidth};
      `}
    ${(props) =>
      !props.isInModal &&
      css`
        width: 100%;
      `}
  }

  .mapboxgl-ctrl-geocoder .suggestions {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mapboxgl-ctrl-geocoder .suggestions > li > a {
    cursor: default;
    display: block;
    padding: 8px 16px;
    color: ${Theme.colors.charcoal900};
  }

  .mapboxgl-ctrl-geocoder .suggestions > li > a:hover {
    background-color: ${Theme.colors.charcoal050};
    text-decoration: none;
    cursor: pointer;
  }

  .mapboxgl-ctrl-geocoder--input {
    font-weight: ${Theme.typography.labelMedium.fontWeight};
    font-size: ${Theme.typography.labelMedium.fontSize};
    line-height: ${Theme.typography.labelMedium.lineHeight};
    min-width: 100%;
    padding: 0 16px 1px;
    border: 1px solid ${Theme.colors.charcoal400};
    border-radius: 3px;
    background-color: transparent;
    margin: 0;
    height: 36px;
    color: ${Theme.colors.charcoal900};
    white-space: nowrap;
    outline: none !important;
  }

  .mapboxgl-ctrl-geocoder--input:placeholder {
    color: ${Theme.colors.charcoal050};
  }

  .mapboxgl-ctrl-geocoder--input:hover {
    box-shadow: 0 0 0 2px ${Theme.colors.hoverHalo};
  }

  .mapboxgl-ctrl-geocoder--input:focus {
    border: 1px solid ${Theme.colors.adskBlue500};
    box-shadow: 0 0 0 2px ${Theme.colors.focusHalo};
  }

  .mapboxgl-ctrl-geocoder--input:disabled {
    background: ${Theme.colors.charcoal050};
    border-color: ${Theme.colors.charcoal200};
    box-shadow: none;
    color: ${Theme.colors.charcoal500};
    cursor: not-allowed;
  }

  .mapboxgl-ctrl-geocoder--icon-search {
    display: none;
  }

  .mapboxgl-ctrl-geocoder--pin-right {
    display: none;
  }

  .mapbox-gl-geocoder--no-results {
    padding: 8px 16px;
  }
`;
